import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


export enum PaymentType {
	BANK = 1,
	CASH = 2,
	CREDIT = 3,
	ONLINE = 4,
	ID = 5,
	Crypto = 6,
	OfflineCard = 7,
	OfflineIBAN = 8,
}

export namespace PaymentType {

	export function getTitle(type: PaymentType): string {
		return Object.keys(PaymentType).find(key => PaymentType[key] === type);
	}

}


@Pipe({
	name: 'paymentTypeText',
	standalone: true
})
export class PaymentTypeTextPipe implements PipeTransform {

	constructor(private translateService: TranslateService) {
	}

	PaymentType = PaymentType;
	translatedText: string;

	transform(value: PaymentType): any {
		this.getTranslate(
			this.PaymentType.getTitle(value)
		);

		return this.translatedText;
	}

	async getTranslate(text: string) {
		text = 'ENUM.PAYMENT_TYPE.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}
